import { getSafeValue } from '../helpers/common';
import { getMinutosPorGol, getGolesPorPartido } from '../helpers/golesHelper';
import { getPlayerDisciplinarySummary } from '../helpers/tarjetasHelper';

export const playerName = (player) => [player.nombre, player.apellidos].filter(Boolean).join(' ');
export const playerKey = (player) => String(player.id ?? `${player.idJugador}:${player.nombreEquipo || player.equipo || ''}`);
export const playerComparisonMetric = (player, key) => {
  if (key === 'minutosJugados') {
    const values = ['minutosJugadosLocal', 'minutosJugadosVisitante'].map((field) => player.minutos?.[field]);
    return values.every((value) => (typeof value === 'number' || typeof value === 'string') &&
      String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0)
      ? values.reduce((sum, value) => sum + Number(value), 0) : null;
  }
  const section = key === 'partidosJugados' ? player.partidos : key.startsWith('goles') ? player.goles : player.tarjetas;
  return section && Object.keys(section).length ? playerMetric(player, key) : null;
};
export const playerPer90 = (player, key) => {
  const minutes = playerComparisonMetric(player, 'minutosJugados');
  const count = playerComparisonMetric(player, key);
  return minutes > 0 && count !== null ? count * 90 / minutes : null;
};
export const playerMetric = (player, key) => {
  const sum = (section, name) => getSafeValue(player, `${section}.${name}Local`) + getSafeValue(player, `${section}.${name}Visitante`);
  let value;
  switch (key) {
    case 'partidosJugados': value = sum('partidos', 'partidosJugados'); break;
    case 'titularidades': value = sum('partidos', 'titularidades'); break;
    case 'convocatorias': value = sum('partidos', 'convocatorias'); break;
    case 'golesTotales': value = getSafeValue(player, 'goles.golesTotales') + getSafeValue(player, 'goles.golesTotalesPenalti'); break;
    case 'golesPenaltis': value = getSafeValue(player, 'goles.golesTotalesPenalti'); break;
    case 'minutosJugados': value = sum('minutos', 'minutosJugados'); break;
    case 'minutosPorGol': value = getMinutosPorGol(player); break;
    case 'golesPorPartido': value = getGolesPorPartido(player); break;
    case 'edad': value = parseInt(player.edad, 10) || 0; break;
    default: {
      const fields = { amarillasTotales: 'yellow', segundasAmarillasTotales: 'secondYellow', rojasTotales: 'red', puntosDisciplinarios: 'points' };
      value = fields[key] ? getPlayerDisciplinarySummary(player)[fields[key]] : 0;
    }
  }
  return Number.isFinite(value) ? value : 0;
};
